import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { COMPANIES_URL } from "./apiEndpoints";
import type { CompanyItem } from "./types";

type Params = {
  domain?: string;
};

type Options = Omit<UseGetServiceOptions<CompanyItem[]>, "route" | "queryKey"> & {
  params?: Params;
};

export const useGetCompanies = (options?: Options) =>
  useGetService<CompanyItem[]>({
    route: COMPANIES_URL,
    queryKey: ["dq-dashboard", "companies", options?.params],
    config: { ...options?.config, params: options?.params },
    retry: false,
    ...(options ?? {}),
  });
